import { defineClassNames } from '../utils/defineClassNames';

export const classes = defineClassNames('dropdown-base', {
  root: { states: ['withWidth'] },
  trigger: {},
  content: { states: ['withWidth'] },
  drawerContent: {},
  list: {},
});
